/**
 * This is a wrapper around the PubSubJS library.
 * It assumes that the PubSubJS library is loaded in the global scope.
 * In the future when we get rid of globally loaded PubSubJS, we can change this class to import PubSubJS from a module.
 */
export type pubSubEventCallBack<TEventData> = (topic: string, eventData: TEventData) => void;

export const PubSub: {
    publish<T>(topic: string, data?: T) : void;
    subscribe<TEventData>(topic: string, callBack: pubSubEventCallBack<TEventData>) : void;
} = globalThis.PubSub;

if (!PubSub || typeof PubSub !== 'object') {
    console.error('PubSub library is not loaded');
}